import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    margin: 1rem 0rem 0rem 0rem !important;
    input {
        margin: 0px !important;
        
    }
    input[readonly]{
        cursor: pointer;
    }
    label {
        display: inline;
        margin-left: 0.625rem;
    }
    ${props =>
        props.disabled &&
        `
    label{
        opacity: 0.4;
    }`};
`;

const DisabledIcon = styled.i`
    color: red;
    font-size: 100%;
    background-color: white;
`;
// const Card = styled.div`
//     border: 1px solid #EAEAEA;
// 	padding: 10px;
// 	border-radius: 4px;
// 	position: relative;
	
//     &:hover{
//         cursor: pointer;
//         box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
//         transition: all 0.2s ease-in-out;
//     }
//     img{
//         width: 100%;
// 	}
// 	${props => (props.selected ? 'border: 1px solid #BDCEEF;' : null)}
// 	${props => (props.selected ? 'box-shadow: 0px 0px 10px rgba(0,0,0,0.1);' : null)}
// 	margin-bottom: 18px;
// 	p{
// 		font-size: 0.8rem;
// 		line-height: 1.2rem;
// 		padding: 12px 0px;
// 	}
// `

// const DisabledCard = styled.div`
//     border: 1px solid #EAEAEA;
// 	padding: 10px;
// 	border-radius: 4px;
// 	position: relative;
	
//     img{
//         width: 100%;
		
// 	}

// 	margin-bottom: 18px;
// 	p{
// 		font-size: 0.8rem;
// 		line-height: 1.2rem;
// 		padding: 12px 0px;
// 		color: grey;
// 	}
// `


// const StyledCheckbox = styled.input`
// 	margin: 0px !important;
// 	margin-top: 0px !important;
// 	margin-right: 12px !important;
// 	height: 18px;
// 	width: 18px;
// `

// const StyledIcon = styled.i`
// 	//position: absolute;
// 	top: 12px;
// 	right: 12px;
// 	color: #FFA348;
// 	font-size: 1.6rem;
// `

// const DisabledIcon = styled.i`
// 	//position: absolute;
// 	top: 12px;
// 	right: 12px;
// 	color: red;
// 	font-size: 1.6rem;
// `

// const ContentCon = styled.div`
// 	display: flex;
// 	align-items: center;
// `

const CheckboxCard = ({option, type, selectOption, deSelectOption}) => {
	if (!option.active) {
        return (
            <Container disabled={true} className="cell small-6  disabled">
                <div>
                    <DisabledIcon className="fas fa-times-circle" />
                    <label>{option.name}</label>
                </div>
            </Container>
        );
    }
    return (
        <Container disabled={false} className="cell small-6  active">
            <div
                onClick={() => (option.selected ? deSelectOption(type, option.value) : selectOption(type, option.value))}
                className="clickable"
            >
                <input
                    readOnly
                    disabled={!option.active}
                    type="checkbox"
                    checked={option.selected}
                />

                <label>{option.name}</label>
            </div>
        </Container>
    );
	// return (
	// 	<div className="cell large-4">
	// 		{props.option.active ? (
	// 			<Card selected={props.option.selected} onClick={() => (props.option.selected ? props.deSelectOption(props.type, props.option.value) : props.selectOption(props.type, props.option.value))}>
				
	// 				<ContentCon>
	// 					<StyledCheckbox checked={props.option.selected} readOnly type="checkbox" value={props.option.value} /><p>{props.option.name}</p>
	// 					{props.option.selected ? (<React.Fragment><div className="flex-fill"></div><StyledIcon className="fas fa-check-circle"></StyledIcon></React.Fragment>) : null}
	// 				</ContentCon>

	// 			</Card>
	// 		) : (
	// 				<DisabledCard>
	// 					<DisabledIcon className="fas fa-times-circle"></DisabledIcon>

	// 					<p><StyledCheckbox type="checkbox" value={props.option.value} />{props.option.name}</p>
	// 				</DisabledCard>
	// 			)}

	// 	</div>

	// );
};

export default CheckboxCard;